module.exports = __webpack_public_path__ + "img/form-1@2x.b671754.png";